// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".te-footer-top a[data-v-37a6d98f],.te-footer-top a[data-v-37a6d98f]:hover{color:#a1a1a1;font-size:.875rem}.te-footer-bottom a[data-v-37a6d98f],.te-footer-bottom a[data-v-37a6d98f]:hover{color:#747474;font-size:.75rem}.te-footer-sns a[data-v-37a6d98f],.te-footer-sns a[data-v-37a6d98f]:hover{color:#747474;font-size:1.25rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
